import {gql} from '@apollo/client';

export const QUERY_ME = gql`
    query getMoneyWwMe ($token: String!) {
        getMoneyWwMe(token: $token) {
            FIO
            paid
        }
    }
`

export const QUERY_CURRENCY = gql`
    query currency {
        currency {
            data {
                attributes {
                    MXN
                    USD
                    EUR
                    KZT
                    VND
                }
            }
        }
    }
`